<img (error)="handleImageError()" (load)="handleImageLoaded()" [attr.alt]="alt()" [attr.aria-hidden]="ariaHidden() || null"
     [attr.height]="height() || null" [attr.loading]="lazyLoading() ? 'lazy': null" [attr.src]="imageSrcSignal()" [attr.width]="width() || null" [style.objectFit]="imageObjectFit()">
